import { openProjectCellModal } from '../../../State/projectCellModal'

export default (period, project, jobs, plannerCell) => (dispatch) => {

  dispatch(openProjectCellModal({ period, project, jobs, plannerCell }))

}
